/* Approved sorting for devices */
export const naturalSort = (a, b, order = "asc") => {
    const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: "base" });

    const cleanedA = a.name?.trim().replace(/\s+/g, " ") || "";
    const cleanedB = b.name?.trim().replace(/\s+/g, " ") || "";

    const comparison = collator.compare(cleanedA, cleanedB);

    return order === "asc" ? comparison : -comparison;
  };

export const compareByNameAscending = (a, b) => naturalSort(a, b, "asc");

export const compareByNameDescending = (a, b) => naturalSort(a, b, "desc");